import { NFT_MEMBERSHIPS_BASE_URL } from '../../../constants/externalUrls'
import { NFT_CONTENT_TYPE } from '../../../constants/nft'

const exclusiveContentUrl = (path) => {
  return NFT_MEMBERSHIPS_BASE_URL + path
}

const exclusiveContentData = (response) => {
  return {
    content: response?.card,
    contentType: NFT_CONTENT_TYPE.HTML
  }
}

export { exclusiveContentUrl, exclusiveContentData }
